/* This code was auto-generated **DO NOT EDIT**
 * If you need to make changes to this file please refer to README.md
 */

import React, { forwardRef } from "react";
import { oneOf, string } from "prop-types";

import componentSizes from "../../constants/componentSizes";
import CheckLG from "../assets/brand/LG/check.svg";
import CheckMD from "../assets/brand/MD/check.svg";
import CheckSM from "../assets/brand/SM/check.svg";
import * as S from "../styled";

const CheckIconAssets = {
  [componentSizes.LG]: CheckLG,
  [componentSizes.MD]: CheckMD,
  [componentSizes.SM]: CheckSM
};

const CheckIcon = forwardRef(
  ({ className, size, ...passThroughProps }, ref) => (
    <S.Icon
      ref={ref}
      className={className}
      src={CheckIconAssets[size]}
      {...passThroughProps}
    />
  )
);

CheckIcon.propTypes = {
  className: string,
  size: oneOf([componentSizes.SM, componentSizes.MD, componentSizes.LG])
};

CheckIcon.defaultProps = {
  className: "",
  size: componentSizes.MD
};

export default CheckIcon;
